import React, { useEffect, useState } from 'react'
import ServicesCard from '../../components/Cards/ServicesCard'
import '../../styles/ClientServices.scss'
import ClientServiceCard from './Cards/ClientServiceCard'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import FilterIcon from '../../assets/imgs/stylers-images/filter-icon.svg'
import JobDetailsModal from '../../components/JobDetailsModal'
import { useDispatch } from 'react-redux'
import { getDataById } from '../../apis/generalApis'
import { ScaleLoader } from 'react-spinners'

const ClientServices = ({ screen }) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [activeTab, setActiveTab] = React.useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const [sortDropdown, setSortDropdown] = React.useState({
    opened: false,
    activeOption: 4,
  })
  const [selectedBooking, setSelectedBooking] = React.useState(null)
  const [clientBookings, setClientBookings] = useState({
    clientPastBookings: [],
    clientScheduledBookings: [],
  })
  const dropdownOptions = [
    { label: '1 Month', value: 1 },
    { label: '3 Months', value: 3 },
    { label: '6 Months', value: 6 },
    { label: '1 Year', value: 12 },
    { label: 'All Time', value: null },
  ]
  const dispatch = useDispatch()
  useEffect(() => {
    getScheduledBookings()
  }, [])

  useEffect(() => {
    getClientPastBookings()
  }, [sortDropdown.activeOption])

  const getClientPastBookings = async () => {
    let body = {
      user_id: user?.id,
      month: dropdownOptions[sortDropdown.activeOption].value,
    }
    setIsLoading(true)
    let result = await getDataById('show-user-past-booking', body)
    setIsLoading(false)
    if (result?.success === true && result?.data) {
      setClientBookings((prev) => ({
        ...prev,
        clientPastBookings: result?.data?.reverse(),
      }))
    }
  }

  const getScheduledBookings = async () => {
    let body = {
      user_id: user?.id,
    }
    setIsLoading(true)
    let result = await getDataById('show-user-schedule-booking', body)
    setIsLoading(false)
    if (result?.success === true && result?.data) {
      setClientBookings((prev) => ({
        ...prev,
        clientScheduledBookings: result?.data?.reverse(),
      }))
    }
  }

  const [jobDetailsModal, setJobDetailsModal] = useState(false)
  const handleJobDetailsModal = () => {
    setJobDetailsModal(!jobDetailsModal)
  }
  const toggleSortDropdown = () => {
    setSortDropdown((previousState) => {
      return { ...previousState, opened: !previousState.opened }
    })
  }

  return (
    <div
      className={
        screen === 'edit-profile'
          ? `client-services bg-white`
          : `client-services`
      }
    >
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100vh',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />

      <div className="container my-3">
        <div className="row mt-3">
          <div className="col-12">
            <div className="custom-tabs d-flex flex-wrap justify-content-center justify-content-md-between justify-content-sm-center">
              <div className="d-flex">
                <div
                  className={`tab ${activeTab === 0 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(0)}
                >
                  <p className="fs-18 color-primary">Scheduled</p>
                </div>
                <div
                  className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                  onClick={() => setActiveTab(1)}
                >
                  <p className="fs-18 color-primary">Completed</p>
                </div>
              </div>
              {activeTab === 1 && (
                <div className="position-relative pointer mt-3 mt-sm-3 mt-md-0 d-flex align-items-center">
                  <div
                    onClick={toggleSortDropdown}
                    className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center bg-white"
                  >
                    <p className="m-0 font-weight-bold">Sort By</p>
                    <p className="m-0 fw-bold d-flex align-items-center gap-1">
                      <span className="mt-1 color-primary">
                        {dropdownOptions[sortDropdown.activeOption].label}
                      </span>
                      <span>
                        <KeyboardArrowDownIcon />
                      </span>
                    </p>
                  </div>
                  {sortDropdown.opened && (
                    <div className="dropdown-content">
                      {dropdownOptions.map((item, index) => (
                        <div
                          key={index}
                          className={`dropdown-option hover-div ${
                            sortDropdown.activeOption === index
                              ? 'active-dropdown-option'
                              : ''
                          }`}
                          onClick={() => {
                            setSortDropdown((prev) => ({
                              ...prev,
                              activeOption: index,
                              opened: false,
                            }))
                          }}
                        >
                          <p className="fs-12">{item.label}</p>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="filter d-flex align-items-center">
                    <img src={FilterIcon} alt="" className="px-2" height={15} />
                    <h3
                      className="m-0 color-primary"
                      style={{ fontSize: '1.2rem' }}
                    >
                      Filters
                    </h3>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {activeTab === 0 && (
          <div className="row mt-0 g-3">
            {clientBookings?.clientScheduledBookings?.length === 0 && (
              <h3 className="text-black">No scheduled bookings.</h3>
            )}
            {clientBookings?.clientScheduledBookings?.map((booking, index) => (
              <div
                key={booking?.id}
                className={
                  screen === 'edit-profile'
                    ? `col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4`
                    : `col-12 col-sm-6 col-md-6 col-lg-4`
                }
              >
                <div>
                  <ServicesCard
                    booking={booking}
                    handleJobDetailsModal={handleJobDetailsModal}
                    setSelectedBooking={setSelectedBooking}
                    getClientPastBookings={getClientPastBookings}
                    getScheduledBookings={getScheduledBookings}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
        {activeTab === 1 && (
          <div className="row mt-0 g-3">
            {clientBookings?.clientPastBookings?.length === 0 && (
              <h3 className="text-black">No past bookings.</h3>
            )}
            {clientBookings?.clientPastBookings.map((booking, index) => (
              <div
                className={
                  screen === 'edit-profile'
                    ? `col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4 pointer`
                    : `col-12 col-sm-6 col-md-6 col-lg-4 pointer`
                }
                key={booking?.id}
              >
                <div>
                  <ServicesCard
                    booking={booking}
                    getClientPastBookings={getClientPastBookings}
                    getScheduledBookings={getScheduledBookings}
                  />
                  {/* <ClientServiceCard
                    stylist={booking?.stylist}
                    service={booking.service}
                    user={booking?.user}
                    booking={booking}
                  /> */}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <JobDetailsModal
        handleJobDetailsModalToggle={handleJobDetailsModal}
        modalOpen={jobDetailsModal}
        booking={selectedBooking}
      />
    </div>
  )
}

export default ClientServices
